// Imports: local files.
import {
  GET_ALL_CATEGORIES_START,
  GET_ALL_CATEGORIES_SUCCESS,
  GET_ALL_CATEGORIES_FAILED,
  GET_ALL_CATEGORIES_RESET,
  GET_ONE_CATEGORY_START,
  GET_ONE_CATEGORY_SUCCESS,
  GET_ONE_CATEGORY_FAILED,
  GET_ONE_CATEGORY_RESET,
  CREATE_CATEGORY_START,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILED,
  CREATE_CATEGORY_RESET,
  UPDATE_ONE_CATEGORY_START,
  UPDATE_ONE_CATEGORY_SUCCESS,
  UPDATE_ONE_CATEGORY_FAILED,
  UPDATE_ONE_CATEGORY_RESET,
  DELETE_ONE_CATEGORY_START,
  DELETE_ONE_CATEGORY_SUCCESS,
  DELETE_ONE_CATEGORY_FAILED,
  DELETE_ONE_CATEGORY_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Industries
     * =======================================================================
     */
    case GET_ALL_CATEGORIES_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_CATEGORIES_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_CATEGORIES_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_CATEGORIES_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Industry
     * =======================================================================
     */
    case GET_ONE_CATEGORY_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_CATEGORY_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_CATEGORY_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_CATEGORY_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New Industry
     * =======================================================================
     */
    case CREATE_CATEGORY_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_CATEGORY_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_CATEGORY_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_CATEGORY_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Industry
     * =======================================================================
     */
    case UPDATE_ONE_CATEGORY_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_CATEGORY_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_CATEGORY_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_CATEGORY_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Industry
     * =======================================================================
     */
    case DELETE_ONE_CATEGORY_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_CATEGORY_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_CATEGORY_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_CATEGORY_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default categoriesReducer;
